import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
const gtmId = import.meta.env.GTM_ID;
const sentryUri = import.meta.env.SENTRY_URI;

// * ===== Styles =====
import "./styles/fonts.scss";
// import "react-tooltip/dist/react-tooltip.css";

import { ToastContainer } from "react-toastify";
import SocketProvider from "./contexts/SocketContext";

import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId,
};

TagManager.initialize(tagManagerArgs);

Sentry.init({
  dsn: sentryUri,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <ToastContainer
      position="bottom-left"
      autoClose={7500}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <SocketProvider>
      <App />
    </SocketProvider>
  </BrowserRouter>
);
